import { createApiSlice } from 'app/createApiSlice'
import { API_FINDORA_LOGS_LIST } from 'utils/apiList'

export const findoraLogsListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'findoraLogsList/api',
  endpoints(builder) {
    return {
      fetchFindoraLogsList: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'createdAt',
          sortdir = 'DESC',
          s,
        }) {
          return {
            url: `/${API_FINDORA_LOGS_LIST}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              s,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchFindoraLogsListQuery,
  useLazyFetchFindoraLogsListQuery,
} = findoraLogsListApiSlice
